import isNil from 'lodash/isNil';
import ChooseProgramForm from '../../../../shared/components/ChooseProgramForm';
import FunnelStepForm from '../../hoc/FunnelStepForm';

export default FunnelStepForm({
  Input: ChooseProgramForm,
  submitOnChange: true,
  isSubmittable: (value) => !isNil(value),
});
